import { Flex, Text } from "@chakra-ui/react";
import { pad_with_zeroes } from "network/helper";

interface ProjectColumnProps {
  projectId: number;
  orderName: string;
}

export const ProjectColumn = ({ projectId, orderName }: ProjectColumnProps) => {
  return (
    <Flex flexDirection="column" gap="4px">
      <Text color="#0B0E10" fontSize="24px" lineHeight="24px" fontWeight="600">
        {pad_with_zeroes(String(projectId), 6)}
      </Text>
      <Text color="#0B0E10" fontSize="14px" lineHeight="18px" fontWeight="400">
        {orderName || ""}
      </Text>
    </Flex>
  );
};
